<template>
	<div>
		<!-- Inicio do Modal de departamento -->
		<div class="modal fade" id="MdGestores" data-backdrop="static">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">Gestor</h4>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-2">
								<span>Código</span>
								<input
									v-model="data.cod"
									type="text"
									disabled
									class="form-control"
								/>
							</div>

							<div class="col-sm-7">
								<span>Razão social</span>
								<input
									v-model="data.razao_social"
									type="text"
									class="form-control"
								/>
							</div>
							<div class="col-sm-3">
								<span>Tipo</span>
								<select
									v-model="data.tipo"
									class="form-control"
								>
									<option value="filial">Filial</option>
									<option value="sede">Sede</option>
								</select>
							</div>
						</div>
						<br />
						<b>Endereço</b>
						<div class="well well-sm">
							<div class="row">
								<div class="col-sm-8">
									<span>Logradouro</span>
									<input
										v-model="data.logradouro"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="col-sm-4">
									<span>Bairro</span>
									<input
										v-model="data.bairro"
										type="text"
										class="form-control"
									/>
								</div>
							</div>

							<div class="row">
								<div class="col-sm-6">
									<span>Cidade</span>
									<input
										v-model="data.cidade"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>CEP</span>
									<input
										v-model="data.cep"
										type="text"
										v-mask="'#####-###'"
										placeholder="_____-___"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>Estado</span>
									<select
										v-model="data.estado"
										class="form-control"
									>
										<option
											v-for="(est, index) in estados"
											:key="index"
											:value="est.uf_estado"
										>
											{{ est.uf_estado }}
										</option>
									</select>
								</div>
							</div>
						</div>

						<b>Documentos</b>
						<div class="well well-sm">
							<div class="row">
								<div class="col-sm-3">
									<span>CNPJ</span>
									<input
										v-model="data.cnpj"
										type="text"
										v-mask="'##.###.###/####-##'"
										placeholder="__.___.___/____-__"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>Inscrição Estadual</span>
									<input
										v-model="data.ie"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>Inscrição Municipal</span>
									<input
										v-model="data.im"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>CNAE</span>
									<input
										v-model="data.cnae"
										type="text"
										v-mask="'##.##-#-##'"
										placeholder="__.__-_-__"
										class="form-control"
									/>
								</div>
							</div>
						</div>

						<b>Contato</b>
						<div class="well well-sm">
							<div class="row">
								<div class="col-sm-3">
									<span>Telefone 1</span>
									<input
										v-model="data.tel1"
										type="text"
										v-mask="'(##) ####-####'"
										placeholder="(__) ____-____"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>Telefone 2</span>
									<input
										v-model="data.tel2"
										type="text"
										v-mask="'(##) ####-####'"
										placeholder="(__) ____-____"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>Celular</span>
									<input
										v-model="data.cel"
										type="text"
										v-mask="'(##) #####-####'"
										placeholder="(__) _____-____"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>Nextel</span>
									<input
										v-model="data.nextel"
										type="text"
										class="form-control"
									/>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									<span>Email</span>
									<input
										v-model="data.email"
										type="text"
										class="form-control"
									/>
								</div>
							</div>
						</div>

						<b>Procurador</b>
						<div class="well well-sm">
							<div class="row">
								<div class="col-sm-9">
									<span>Procurador</span>
									<input
										v-model="data.procurador"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>CPF</span>
									<input
										v-model="data.cpf"
										type="text"
										v-mask="'###.###.###-##'"
										placeholder="___.___.___-__"
										class="form-control"
									/>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-3">
									<span>RG</span>
									<input
										v-model="data.rg"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="col-sm-3">
									<span>Estado Civil</span>
									<select
										v-model="data.estado_civil"
										class="form-control"
									>
										<option value="solteiro">
											Solteiro(a)
										</option>
										<option value="casado">
											Casado(a)
										</option>
										<option value="viuvo">Viúvo(a)</option>
										<option value="outro">Outro</option>
									</select>
								</div>
								<div class="col-sm-6">
									<span>Observação</span>
									<input
										v-model="data.obs"
										type="text"
										class="form-control"
									/>
								</div>
							</div>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>

						<aBtn
							action="private-save-managers"
							@click="save"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- Fim do Modal de departamento -->
		<!-- <pre> {{data}} </pre> -->
	</div>
</template>
<script>
	import reset from './reset.js';
	import estados from 'js/estados';
	import clone from 'js/clone';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';

	export default {
		name: 'MdGestores',
		props: ['dataIn'],
		components: { aBtn },
		data() {
			return {
				data: clone(reset),
				estados: clone(estados),
			};
		},
		methods: {
			save() {
				WBS.send('private-save-managers', this.data, (resp) => {
					if (resp.status == 'success') {
						$('#MdGestores').modal('hide');
						toastr.success('Dados salvos com sucesso!');
						this.$emit('update');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
			open(data = null) {
				if (data == null) this.data = clone(reset);
				else this.data = clone(data);
				$('#MdGestores').modal('show');
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/managers/modal.vue